import { render } from "./About.vue?vue&type=template&id=292ce777&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=292ce777&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-292ce777"

export default script